import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const HP_INNOVATIVE_SWING_I18N_NAMESPACE =
  '@mc/next/experiments/hp-innovative-swing'

export const i18nInstance = registerI18nResources({
  namespace: HP_INNOVATIVE_SWING_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
